import * as yup from 'yup'

export const CREATECOURSEINSTANCESCHEMA = yup.object().shape({
  courseId: yup.string().required(),
  title: yup.string().required(),
  startDate: yup.date().required(),
  endDate: yup.date().required(),
})
